<script setup>
import { ref, computed } from 'vue'
import { useAnalysisStore } from '@/store/modules/analysis'
import fiveMixin from '@/composables/fiveMixin'
const store = useAnalysisStore()
const props = defineProps({
  sajuganjiArray: {
    type: Array,
    default: () => [],
  },
  sajuganjiKorArray: {
    type: Array,
    default: () => [],
  },
  selectedDescNavSub: {
    type: String,
    default: '',
  },
  langMode: {
    type: String,
    default: 'CHNKOR',
  },
})
const { getColorFive } = fiveMixin()
const toggleBirthClass = ref('open')
const toggleBirthClassTxt = ref('접기')
const toggleBirth = () => {
  if (toggleBirthClass.value === '') {
    toggleBirthClass.value = 'open'
    toggleBirthClassTxt.value = '접기'
  } else {
    toggleBirthClass.value = ''
    toggleBirthClassTxt.value = '보기'
  }
}

/** 이름 */
const name = computed(() => store.userName)
</script>
<template>
  <div class="eight-box myfive-birth-box" :class="toggleBirthClass">
    <div class="name-box">
      <div class="txt1-box">
        <span class="name">{{ name }}님의 사주 원국</span>
        <!-- <button class="btn-person-order"><IconOrder /> <span>순서</span></button> -->
      </div>
      <div class="txt2-box">
        <button class="btn-person-fold" @click="toggleBirth()">
          {{ toggleBirthClassTxt }}
          <IconFold v-if="toggleBirthClass === 'open'" />
          <IconFoldDown v-if="toggleBirthClass === ''" />
        </button>
      </div>
    </div>
    <div class="eight-birth-box">
      <div class="sky-box" :class="{ normal: selectedDescNavSub === 'fourth' }">
        <div class="s-tit">천간</div>
        <div class="text-box txt-big">
          <div class="s-box" v-for="(item, index) in sajuganjiArray" :key="index">
            <div class="ss-tit">{{ item.pos }}</div>
            <span class="txt-round xl" :class="[getColorFive(item.sky), langMode]">
              <em class="chn">{{ item.sky }}</em>
              <em class="txt-main">{{ sajuganjiKorArray?.[index]?.sky || '' }}</em>
            </span>
          </div>
        </div>
      </div>

      <div class="earth-box" :class="{ normal: selectedDescNavSub === 'third' }">
        <div class="s-tit">지지</div>
        <div class="text-box txt-big">
          <div class="s-box" v-for="(item, index) in sajuganjiArray" :key="index">
            <div class="ss-tit">{{ item.pos }}</div>
            <span class="txt-round xl" :class="[getColorFive(item.earth), langMode]">
              <em class="chn">{{ item.earth }}</em>
              <em class="txt-main">{{ sajuganjiKorArray?.[index]?.earth || '' }}</em>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style lang="scss">
.txt-big .txt-round.five01 {
  box-shadow: 10px 10px 10px 0 rgba(194, 53, 53, 0.2);
}
.txt-big .txt-round.five02 {
  box-shadow: 10px 10px 10px 0 rgba(64, 64, 64, 0.2);
}
.txt-big .txt-round.five03 {
  box-shadow: 10px 10px 10px 0 rgba(94, 159, 28, 0.2);
}
.txt-big .txt-round.five04 {
  box-shadow: 10px 10px 10px 0 rgba(148, 148, 148, 0.2);
}
.txt-big .txt-round.five05 {
  box-shadow: 10px 10px 10px 0 rgba(219, 152, 35, 0.2);
}

.eight-box .eight-birth-box .earth-box.normal,
.eight-box .eight-birth-box .sky-box.normal {
  .ss-tit {
    color: var(--Gray-400, #c2c2c2);
  }
  .s-tit {
    color: var(--Gray-400, #c2c2c2);
  }
  .txt-big .txt-round {
    background: var(--Gray-200, #f8f8f8);
    color: var(--Gray-400, #c2c2c2);
    box-shadow: none;
  }
}
.myfive-birth-box {
  .txt-big {
    .txt-round.chn {
      .txt-main {
        display: none;
      }
    }
    .txt-round.kor {
      .chn {
        display: none;
      }
      .txt-main {
        font-size: 30px;
      }
    }
  }
}
</style>
